// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewNotificationPage_container__L7sTZ"};